<script>
import _ from "lodash";
import CommonRules from "@/mixins/CommonRules";
import UserAuth from "@/mixins/UserAuth";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import Languages from "@/mixins/dictionaries/Languages";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import ProjectsDigestsItemQuotes from "@/components/Projects/ProjectsDigestsItemQuotes.vue";
import ProjectsQuotesModal from "@/components/Projects/ProjectsQuotesModal.vue";
import VBtnMenu from "@/components/commonComponents/VBtnMenu.vue";
import VTextFieldDatePicker from "@/components/commonComponents/VTextFieldDatePicker.vue";
import BpApproveDecline from "@/components/commonComponents/BpApproveDecline.vue";
import Comments from "@/components/commonComponents/Comments.vue";
import roscongressUrl from "@/utils/roscongressUrl";
import History from "@/components/commonComponents/History.vue";
import BpStatusStepper from "@/components/commonComponents/BpStatusStepper.vue";
import VBtnMenuItem from "@/components/commonComponents/VBtnMenuItem.vue";

export default {
    name: "ProjectsDigestsItem",
    components: {
        VBtnMenu,
        VBtnMenuItem,
        BpStatusStepper,
        History,
        Comments,
        BpApproveDecline,
        VTextFieldDatePicker,
        ProjectsQuotesModal,
        ProjectsDigestsItemQuotes,
        VFormModified,
        AjaxLoad,
    },
    mixins: [
        CommonRules,
        UserAuth,
        ComponentsKeys,
        Languages,
    ],
    data() {
        return {
            isResolvedRaw: true,
            isValid: false,
            isSubmit: false,
            wasModified: false,
            result: false,
            idCompany: null,
            original: {
                quotes: [],
            },
            data: {},
            notifyOptions: {
                title: 'Дайджест',
            },
            componentsKeys: {
                projectsQuotesModal: this.getRandomKey('projectsQuotesModal'),
            },
            tab: null,
        };
    },
    computed: {
        isResolved: {
            get() {
                return this.isNew || this.isResolvedRaw;
            },
            set(v) {
                this.isResolved = v;
            },
        },
        isDisabled() {
            return this.isNew ?
                !this.user?.permissions?.byModule?.digests?.canCreate :
                !(this.user?.permissions?.byModule?.digests?.canUpdate && this.data?.permissions?.canUpdate);
        },
        isCanSubmit() {
            return !this.isDisabled && this.isValid && this.wasModified && !this.isSubmit && this.isResolved;
        },
        isCanAction() {
            return !this.wasModified && !this.isSubmit && this.isResolved && this.isValid;
        },
        isShowPublishButton() {
            return this.data?.permissions?.canPublish;
        },
        isCanPublish() {
            return this.isCanAction && this.isShowPublishButton;
        },
        idProject() {
            return this.$store.getters.breadCrumbs.event?.EPS_PROJECT_ID?.VALUE || null;
        },
        idDigests() {
            return parseInt(this.$route.params.ID_DIGESTS);
        },
        isNew() {
            return !this.idDigests;
        },
        isLoading() {
            return !this.isResolved || this.isSubmit;
        },
        loadUrl() {
            return this.idProject && this.idDigests && this.$apiUrl.getProjectDigestUrl({
                id_project: this.idProject,
                id_digests: this.idDigests,
            }) || undefined;
        },
        saveUrl() {
            return this.isNew ?
                this.$apiUrl.getProjectDigestsUrl({
                    id_project: this.idProject,
                }) :
                this.loadUrl;
        },
        roscongressDigestUrl() {
            const idAnalytics = this.data?.id_analytics;
            return idAnalytics && roscongressUrl.getDigestUrl({id_analytics: idAnalytics});
        },
        roscongressDigestBitrixUrl() {
            const idAnalytics = this.data?.id_analytics;
            return idAnalytics && roscongressUrl.getDigestBitrixUrl({id_analytics: idAnalytics});
        },
    },
    methods: {
        isDisabledField(field) {
            return this.isNew ?
                !this.user?.permissions?.byModule?.digests?.canCreate :
                !(this.user?.permissions?.byModule?.digests?.canUpdate && this.data?.permissions?.isEditableField[field]);
        },
        doSave(callbackFn) {
            this.isSubmit = true;
            let i = 0;
            const method = this.isNew ? 'post' : 'put',
                data = Object.assign({}, this.data, {
                    quotes:
                        _(this.data.quotes)
                            .map((v) => {
                                return {
                                    id: v.id,
                                    i: ++i,
                                }
                            })
                            .keyBy('id')
                            .mapValues('i')
                            .value()
                });

            return this.$api[method](this.saveUrl, data)
                .then((response) => {
                    this.result = response;
                    this.notifySuccess('Успешно сохранен');
                    if (_.isFunction(callbackFn)) {
                        callbackFn(response);
                    }
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickSaveAndClose() {
            this.doSave(this.close);
        },
        onClickSave() {
            this.doSave((response) => {
                this.original = response.data.data;
                if (this.isNew) {
                    this.$router.replace({params: {ID_DIGESTS: this.original.id}});
                }
                this.$refs.history?.load();
            });
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.$router.push({name: 'ForumEventDigests'});
        },
        onClickAddQuote() {
            this.$refs.projectsQuotesModal
                .show()
                .catch(this.notifyError)
                .finally(() => {
                    this.componentsKeys.projectsQuotesModal = this.updateComponentKey('projectsQuotesModal');
                });
        },
        onDblClickRowQuote(e, {item}) {
            if (_.find(this.data.quotes, {id: item.id})) {
                this.notifyWarn('Цитата уже добавлена');
            } else {
                this.data.quotes.push(item);
            }
        },
        onClickPublish() {
            this.isSubmit = true;
            this.$api.post(this.loadUrl)
                .then(() => {
                    this.notifySuccess('Успешно опубликован.');
                    this.reload();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onConfirmBpApproveDecline(data) {
            const url = this.$apiUrl.getProjectDigestApproveDeclineUrl({
                id_digests: this.idDigests,
                id_project: this.idProject,
                action: data.action,
                role: data.role,
            });
            return this.$api.put(url, data.form)
        },
        onSuccessBpApproveDecline() {
            this.reload();
        },
        reload() {
            this.$refs.ajax.load()
            this.$refs.comments.load();
            this.$refs.history?.load();
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        v-model="original"
        :active="!isNew"
        :url="loadUrl"
        :transform="response => response.data.data"
        :resolved.sync="isResolvedRaw"
    >
        <v-form-modified
            v-model="isValid"
            :original="original"
            :modified.sync="data"
            :was-modified.sync="wasModified"
            :disabled="isLoading"
            @submit.prevent="onClickSaveAndClose"
        >
            <v-card :loading="isLoading">
                <v-container fluid class="down-top-padding">
                    <v-row no-gutters>
                        <v-col>
                            <v-card>
                                <v-toolbar flat>
                                    <v-toolbar-title>
                                        {{ isNew ? 'Новый дайджест' : original.name }}
                                    </v-toolbar-title>
                                </v-toolbar>
                                <v-card-text class="pt-0">
                                    <bp-status-stepper
                                        :data="data"
                                        :published-url="roscongressDigestUrl"
                                        :published-bitrix-url="roscongressDigestBitrixUrl"
                                        published-url-tooltip="Открыть дайджест на Портале"
                                    ></bp-status-stepper>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card>
                                <v-tabs v-model="tab">
                                    <v-tab tab-value="common">Общее</v-tab>
                                    <v-tab tab-value="history" v-if="!isNew">История</v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="tab">
                                    <v-tab-item value="common">
                                        <v-container>
                                            <v-row no-gutters>
                                                <v-col>
                                                    <v-autocomplete
                                                        v-model="data.language"
                                                        :disabled="isDisabledField('language')"
                                                        :items="dictionaries.languages"
                                                        :rules="[rules.required]"
                                                        label="Язык"
                                                        class="required"
                                                        item-text="name"
                                                        item-value="id"
                                                    ></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col>
                                                    <v-text-field
                                                        v-model="data.name"
                                                        :rules="[rules.requiredTrim, rules.minLength(3)]"
                                                        :disabled="isDisabledField('name')"
                                                        label="Наименование"
                                                        class="required"
                                                        autofocus
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col>
                                                    <v-text-field-date-picker
                                                        v-model="data.date_origin"
                                                        :rules="[rules.required]"
                                                        :disabled="isDisabledField('date_origin')"
                                                        label="Дата выхода"
                                                        class="required"
                                                    ></v-text-field-date-picker>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col>

                                                    <projects-digests-item-quotes
                                                        v-model="data.quotes"
                                                        :id-project="idProject"
                                                        :disabled="isDisabledField('quotes')"
                                                        :was-modified="wasModified"
                                                        :is-can-submit="isCanSubmit"
                                                        @reload="() => $refs.ajax.load()"
                                                        @save="onClickSave"
                                                        @add="onClickAddQuote"
                                                    ></projects-digests-item-quotes>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item value="history">
                                        <history
                                            ref="history"
                                            :url="$apiUrl.getProjectDigestHistoryUrl({id_project: idProject, id_digests: idDigests})"
                                            :table-props="{footerProps:{itemsPerPageOptions: [-1]}}"
                                        ></history>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-card>
                        </v-col>
                        <v-col v-if="!isNew && idProject" cols="3">
                            <v-card height="100%">
                                <v-toolbar flat>
                                    <v-toolbar-title>Комментарии</v-toolbar-title>
                                </v-toolbar>
                                <comments
                                    ref="comments"
                                    :url="$apiUrl.getProjectDigestCommentsUrl({id_project: idProject, id_digests: idDigests})"
                                ></comments>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <bp-approve-decline
                        :is-can-action="isCanAction"
                        :permissions="data?.permissions"
                        @confirm="onConfirmBpApproveDecline"
                        @success="onSuccessBpApproveDecline"
                        approve-question="Вы уверены что хотите отправить дайджест на утверждение?"
                        approve-as-moderator-question="Вы уверены что хотите одобрить дайджест?"
                        decline-question="Вы уверены что хотите отклонить дайджест?"
                    >
                        <template v-slot:append>
                            <v-btn
                                v-if="isShowPublishButton"
                                :disabled="!isCanPublish"
                                @click="onClickPublish"
                            >
                                Опубликовать
                            </v-btn>
                        </template>
                    </bp-approve-decline>

                    <v-spacer></v-spacer>
                    <v-btn @click="onClickCancel">
                        Отмена
                    </v-btn>
                    <v-btn-menu
                        :disabled="!isCanSubmit"
                        type="submit"
                        color="primary"
                    >
                        Сохранить
                        <template v-slot:menu>
                            <v-btn-menu-item
                                @click="onClickSaveAndClose"
                            >
                                ... и закрыть
                            </v-btn-menu-item>
                            <v-btn-menu-item
                                @click="onClickSave"
                            >
                                ... и продолжить
                            </v-btn-menu-item>
                        </template>
                    </v-btn-menu>
                </v-card-actions>

                <projects-quotes-modal
                    ref="projectsQuotesModal"
                    :key="componentsKeys.projectsQuotesModal"
                    :id-project="idProject"
                    @dblclick:row="onDblClickRowQuote"
                ></projects-quotes-modal>
            </v-card>
        </v-form-modified>
    </ajax-load>
</template>

<style scoped lang="scss">
::v-deep {
    .v-stepper {
        min-width: 100%;
        width: 100%;
        max-width: 100%;
    }

    .v-tabs {
        border-bottom: 1px solid #c0c0c044;
    }
}
::v-deep {
    .v-card__actions {
        .v-btn {
            &.v-btn-with-menu {
                .v-btn__content {
                    .v-divider--vertical {
                        margin: 0 0 0 8px;
                    }
                }
            }
        }
    }
}

</style>
